if (typeof window !== 'undefined' && !window.process) {
  window.process = { env: {} };
}

if (typeof window !== 'undefined') {
  window.global = window.global || window;
}
